import { Command, HttpMethod } from "~/extensions/api";
import { myPageStore } from "~/store/MyPageStore";
export class UpdateForComplete extends Command {
    constructor() {
        super(HttpMethod.Post, "kaiyaku/complete");
    }
    OrgNyukyokeiyakuNo = -1;
    static create() {
        let command = new UpdateForComplete();
        command.OrgNyukyokeiyakuNo = myPageStore.selectedNyukyokeiyaku.orgNyukyokeiyakuNo;
        return command;
    }
}
